import React, { Suspense } from 'react'
import type { RouteObject } from 'react-router-dom'
import { LayoutMain } from '../../../../layouts/LayoutMain/LayoutMain'
import { AuthRoute } from '../../../../routes/routes.components'
import { dashboardRoutePaths } from './dashboard_route_paths'

const DahsboardPageLazy = React.lazy(() => import('../screens/Dashboard.page'))

export const dashboardRoutes: RouteObject[] = [
  {
    path: dashboardRoutePaths.dashboard,
    element: (
      <AuthRoute>
        <LayoutMain />
      </AuthRoute>
    ),
    children: [
      {
        path: '',
        element: (
          <Suspense fallback={<div></div>}>
            <DahsboardPageLazy />
          </Suspense>
          // <DashboardPage />
        ),
      },
    ],
  },
]
